export default {
  rooms: [],
  pagination: {},
  room: {}
}
